<div class="-collapse uk-child-width-expand@s">
    <div class="">
        <span class="colorlabel">{{labelOne}}</span><br>
        <input type="number" class="uk-input tethered-input" pattern="\d*" [(ngModel)]="valueOne" min="0" max="100" (ngModelChange)="updateValueOne()">
    </div>
    <div class="">
        <span class="colorlabel">{{labelTwo}}</span><br>
        <input type="number" class="uk-input tethered-input" pattern="\d*" [(ngModel)]="valueTwo" min="0" max="100" (ngModelChange)="updateValueTwo()">
    </div>
</div>
